:host {
  display: inline-block;
}

:host [slot='control'] {
  --aha-button--padding-vertical: var(--spacer-1);
  --aha-button--padding-horizontal: var(--spacer-1);
  --aha-button--line-height: 0px;
}

:host aha-menu {
  height: inherit;
  width: inherit;
}

:host .pickable-icon:hover,
aha-portal-outlet .pickable-icon:hover {
  background-color: var(--theme-blue-dropzone);
}
